module.exports = __webpack_public_path__ + "assets/img/Spark-Systems-Website.0c9fafad.webp";